import React from 'react';
import { User } from 'lucide-react';

/**
 * UserAvatar Component
 * @param {Object} user - User object containing profile_pic and full_name
 * @param {string} size - Size of the avatar (xs, sm, md, lg, xl, or tailwind class)
 * @param {string} className - Additional classes for the container
 * @param {string} avatarClassName - Additional classes for the avatar div
 * @param {boolean} indicator - Whether to show the online indicator
 * @param {string} shape - Shape of the avatar ('circle' or 'square')
 */
const UserAvatar = ({ 
  user, 
  size = 'md', 
  className = '', 
  avatarClassName = '', 
  indicator = false,
  shape = 'circle'
}) => {
  const sizeClasses = {
    xs: 'w-6 h-6',
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16',
    '2xl': 'w-20 h-20',
  };

  const iconSizes = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8',
    '2xl': 'w-10 h-10',
  };

  const currentSizeClass = sizeClasses[size] || size;
  const currentIconSizeClass = iconSizes[size] || 'w-5 h-5';
  
  const shapeClass = shape === 'circle' ? 'rounded-full' : 'rounded-2xl';

  return (
    <div className={`relative ${currentSizeClass} ${className}`}>
      <div className={`w-full h-full ${shapeClass} overflow-hidden shadow-lg ring-2 ring-white bg-gradient-to-br from-blue-500 via-purple-600 to-pink-500 flex items-center justify-center ${avatarClassName}`}>
        {user?.profile_pic ? (
          <img 
            src={user.profile_pic} 
            alt={user?.full_name || 'User'} 
            className="w-full h-full object-cover"
            referrerPolicy="no-referrer"
          />
        ) : (
          <User className={`${currentIconSizeClass} text-white`} />
        )}
      </div>
      {indicator && (
        <div className={`absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-emerald-400 rounded-full border-2 border-white`}></div>
      )}
    </div>
  );
};

export default UserAvatar;
